import { render, staticRenderFns } from "./HelpMenu.vue?vue&type=template&id=0c7a01b4&scoped=true"
import script from "./HelpMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./HelpMenu.vue?vue&type=script&setup=true&lang=js"
import style0 from "./HelpMenu.vue?vue&type=style&index=0&id=0c7a01b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7a01b4",
  null
  
)

export default component.exports